import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Grid, Card } from '@material-ui/core';
import { toggleTourOn, toggleTourOff } from '../../redux/actions/toggleTourActions';
import { expandSidebar } from '../../redux/actions/sidebarActions';
import '../../scss/component/getting-started.scss';

class GettingStarted extends Component {

  toggleTour = () => {
    this.props.dispatch(toggleTourOn());
    this.props.dispatch(expandSidebar());
    this.props.history.push('/app/tour/playbook');
  };

  componentDidMount(){
    this.props.dispatch(toggleTourOff());
  }

  updateFromGettingStarted(){
    localStorage.setItem('fromGettingStarted', true)
  }

  render() {
    return (
        <div>
          <Grid container>
            <Grid item className="getting-started" xs={12}>
              <div id="welcome">
                Welcome to Posture, {this.props.user.given_name}
              </div>
            </Grid>

            <Grid item className="getting-started" xs={12}>
              <div id="demonstrate">
                We can't wait to help you manage and demonstrate<br/>compliance in a simple
                and affordable way.
              </div>
            </Grid>

            <Grid item className="getting-started" xs={12}>
              <div id="experience">
                First, let's get a clear picture of where you are in your<br/>compliance
                journey so we can customize your Posture<br/>experience.
              </div>
            </Grid>

            <Grid item className="getting-started" xs={12}>
              <Card 
                onClick={() => {this.props.history.push('/app/assessment');
                this.updateFromGettingStarted();
              }}
                id="assessment-card"
              >
                <div id="assessment">
                  Take a Compliance Assessment
                </div>
              </Card>
            </Grid>

            <Grid item className="getting-started" xs={12}>
              <div
                id="tour"
                onClick={() => {
                  this.toggleTour();
                }}>
                Get a Tour of Posture first.
              </div>
            </Grid>
          </Grid>
        </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    sidebar: state.sidebar,
    toggleTour: state.toggleTour
  }
}

export default connect(mapStateToProps, null)(withRouter(GettingStarted));


// WEBPACK FOOTER //
// ./src/components/getting-started/GettingStarted.js